import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import edit from "../../../assets/images/edit.png";
import trash from "../../../assets/images/trash.png";
import BellR from "../../../assets/images/bell_de.png";
import BellG from "../../../assets/images/bell_flt.png";
import MailR from "../../../assets/images/mail_dlt.png";
import MailG from "../../../assets/images/mail_at.png";
import Userview from "../../../assets/images/useer_view.png";
import Select from 'react-select';
import { toast } from 'react-toastify';

import ConfModal from '../../../Components/common/ConfModal.js';
import { CallApi } from '../../../Components/common/CommonFunctions.js';

const AddressBook = ({ mode, sendData }) => {
    const isMounted = useRef(false);
    const [modalShow, setModalShow] = useState(false);
    const [editId, setEditId] = useState('');
    const [deleteId, setDeleteId] = useState('');
    const [modalConf, setModalConf] = useState(false);
    const [deleteFunction, setDeleteFunction] = useState(null);
    const userRole = [
        { label: 'User', value: 'E' },
        { label: 'Admin', value: 'S' },
        // {label: 'Company Super Admin', value: 'SA'}
    ];
    const taskType = [
        { label: "Custom", value: "Custom" },
        { label: "Finding", value: "Finding" },
        { label: "Finding (minor)", value: "Finding (minor)" },
        { label: "Finding (Major)", value: "Finding (Major)" },
        { label: "Observation", value: "Observation" },
        { label: "Observation (minor)", value: "Observation (minor)" },
        { label: "Observation (Major)", value: "Observation (Major)" },
        { label: "Improvement opportunity", value: "Improvement opportunity" }
    ];

    const handleAddButtonClick = () => {
        setModalShow(true);
    };
    const handleEditButtonClick = (userId) => {
        setEditId(userId);
        setModalShow(true, { id: userId });
    };
    const handleModalClose = () => {
        setModalShow(false);
        setFormData({});
        setEditId('');

    };

    const [gridData, setGridData] = useState([]);
    const [gridSelect, setGridSelect] = useState([]);
    const [userList, setUserList] = useState([]);
    const fetchuser = async () => {
        CallApi({
            endPoint: 'uld-setting/get-user-list',
            payload: { status: 'A' },
            onSuccess: (data) => {
                const innerData = data.data.Rows;

                const transformData = innerData ? innerData.map((item) => ({
                    label: item.first_name + ' ' + item.last_name,
                    value: item.user_id
                })) : []
                setUserList(transformData)
            },
            onError: (msg) => toast.error(msg)
        });
    };
    const fetchData = () => {
        CallApi({
            endPoint: 'surveillance-report/address-list-all?type=service_recovery',
            method: 'get',
            onSuccess: (data) => {
                const innerData = data.data.Rows;

                setGridData(innerData);
            },
            onError: (msg) => toast.error(msg)
        });
    };
    useEffect(() => {
        if (isMounted.current) return;
        
        fetchData();
        fetchuser();
        isMounted.current = true;
    }, []);

    const gridRef = useRef(null);
    const gridSelectRef = useRef([]);
    let checkUlds = [];
    useEffect(() => {
        // console.log("🚀 ~ ExportActive ~ PPP:", gridData)
        if (gridRef.current) {

            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'org_id', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'email', type: 'string' },
                    { name: 'number', type: 'string' },
                    { name: 'shipper_address', type: 'string' },
                ],
                localdata: gridData,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);

            const columns = [
                ...(!mode ? [
                    {
                        text: 'Actions',
                        filterable: false,
                        cellsrenderer: function () {
                            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /><img src="' + trash + '" class="row_delete" /></div>';
                        },
                        width: '8%'
                    }] : []),
                { text: 'Name', filtertype: 'textbox', datafield: 'name', width: '16%', cellclassname: '', },
                { text: 'Email ID', filtertype: 'textbox', datafield: 'email', width: '20%', cellclassname: '', },
                { text: 'Number', filtertype: 'textbox', datafield: 'number', width: '16%', cellclassname: '', },
                { text: 'Address', filtertype: 'textbox', datafield: 'shipper_address', width: '22%', cellclassname: '', },
            ];


            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: true,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                selectionmode: mode == 'modal' ? 'checkbox' : '',
                pageable: true,
                pageSize: 10,
                pagerButtonsCount: 10,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 50,
                columnsheight: 45,
            };


            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRef.current).on('click', '.row_edit', function (row) {

                const rowDiv = window.$(this).closest('[role="row"]');

                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
                const id = rowData.id;
                console.log('Row Data:', rowData);
                setEditId(id);
                setModalShow(true);
                const cDtata = { ...rowData, location: rowData.shipper_address }
                setFormData(prev => {

                    const { shipper_address, ...rest } = cDtata;
                    return rest;
                });
            });
            window.$(gridRef.current).on('click', '.row_delete', function (row) {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);
                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;

                    const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log('Row Data:', rowData);
                        setDeleteId(rowData.id);
                        setModalConf(true)
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }

            });
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));

                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }
            });
        }

    }, [gridData]);

    const [formData, setFormData] = useState({
        task_type: 'gfsdsfdg'
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleConfirmDelete = () => {
        deleteRow();
        setModalConf(false);

    };

    const handleCancelDelete = () => {
        setDeleteId('')
        setModalConf(false);
    };
    const deleteRow = (selectedId) => {
        // CallApi({
        //     endPoint: 'organisation-department/delete-restore',
        //     payload: { id: deleteId },
        //     onSuccess: (data) => {
        //         if (data.data.response_code === 200) {
        //             toast.success('Department Removed Successfully')
        //             fetchData();
        //             setDeleteId('');
        //         } else {
        //             toast.error(data.response_msg);
        //         }
        //     },
        //     onError: (msg) => toast.error(msg)
        // });
    };

    const validateData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!formData.email) {
            toast.error('Insert valid email address');
            isValid = false;
            // } else if (!validateEmail(formData.email)) {
            //     toast.error('Invalid email address');
            //     isValid = false;
        } else if (formData.name) {
            toast.error('Insert valid email address');
            isValid = false;
        } else if (!formData.number) {
            toast.error('Number must not be blank');
            isValid = false;
        }
        else {
            return isValid;
        }
    };
    const handleUpdate = async () => {
        // if (!validateData()) {
        //     // toast.error('Department Name must not be blank');
        //     return;
        // }
        CallApi({
            endPoint: 'cargo-customer-address/add-update',
            payload: formData,
            onSuccess: (data) => {
                if (data.data.response_code === 200) {
                    fetchData();
                    toast.success(data.data.response_msg)
                    setModalShow(false)
                } else {
                    toast.error(data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    const handleAddMail = () => {
        const sendMail = gridSelect.map(ids => ids.email);
        sendData(sendMail)
    }

    const SBack = localStorage.getItem('SettingsBack');

    return (
        <>
            {/* <div className="">{console.log('delete id ', deleteId)}
        <Header logo_url={SBack ? SBack : '/ServiceRecovery'} />
        <div className="main-panel">

          <div className="row">
            <LeftSettings /> */}
            {/* {console.log('FormData', formData)} */}
            {!mode &&
                <>
                    {modalConf &&
                        <ConfModal
                            header='Confirm Delete'
                            subHeader='If you proceed with the change, Template data will be removed. Are you sure you want to continue?'
                            modalConf={handleConfirmDelete}
                            closeModal={handleCancelDelete}
                            primaryBtn='Yes'
                            secondaryBtn='No'
                        />
                    }
                    <div className='col-9 col-xxl-9 stting_right'>
                        <div className='settingbg_right'>
                            <h4>Addressbook Settings</h4>
                            <p>Lorem ipsum dolor sit amet, consectetur</p>
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <Button variant="primary createplan" onClick={handleAddButtonClick} >
                                        <FontAwesomeIcon icon={faPlus} /> Add Addressbook
                                    </Button>
                                </div>
                            </div>
                            <div ref={gridRef} className='bookinggrid userstting'></div>
                            {/* </div> */}
                        </div>
                    </div>
                    <Modal show={modalShow} centered onHide={handleModalClose} className='addfrom' >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {editId &&
                                    !editId == '' ? (
                                    <>
                                        Edit Addressbook
                                    </>
                                ) : (
                                    <>
                                        Add Addressbook
                                    </>
                                )
                                }
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group as={Row} className='mb-2'>
                                <Col sm="12">
                                    <Form.Label>Department name <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control
                                        type="text" name='name'
                                        placeholder="Name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className='mb-2'>
                                <Col sm="12">
                                    <Form.Label>Email Id <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control
                                        type="email" name='email'
                                        placeholder="Email Id"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className='mb-2'>
                                <Col sm="12">
                                    <Form.Label>Number <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control
                                        type="number" name='number'
                                        placeholder="Number"
                                        value={formData.number}
                                        onChange={handleChange}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className='mb-2'>
                                <Col sm="12">
                                    <Form.Label>Address<span className='text-danger'>*</span></Form.Label>
                                    <Form.Control
                                        type="text" name='location'
                                        placeholder="Location"
                                        value={formData.location}
                                        onChange={handleChange}
                                    />
                                </Col>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='d-flex w-50 mx-auto are_bottom'>
                                <Button variant="secondary" onClick={() => setModalShow(false)}>
                                    Discard
                                </Button>
                                <Button variant="primary" onClick={handleUpdate}>
                                    Save
                                </Button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </>
            }
            {mode === 'modal' &&
                <div className='text-end'>
                    <div ref={gridRef} className='bookinggrid userstting'></div>
                    <Button variant="primary" className='mt-3' onClick={handleAddMail}> Add </Button>
                </div>
            }
        </>
    )
}

export default AddressBook